export enum AccessCallStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  CALLING = 'CALLING',
  FINISHED_TIMED_OUT = 'FINISHED_TIMED_OUT',
  FINISHED_ACCESS_ALLOWED = 'FINISHED_ACCESS_ALLOWED',
  FINISHED_ACCESS_DENIED = 'FINISHED_ACCESS_DENIED'
}
